import axiosInstance from "./api_helper";

const stockService = {
    search: async ({ query = '', page = 0, size = 10, productId = null }) => {
        const params = { query, page, size };
        if (productId) {
            params.productId = productId;
        }
        return axiosInstance.get('/api/stocks/search', { params });
    },
    delete: async (id) => {
        return axiosInstance.delete(`/api/stocks/${id}`);
    },
    save: async (stock) => {
        return axiosInstance.post(`/api/stocks`, JSON.stringify(stock));
    },
    update: async (payload) => axiosInstance.put('/api/stock', payload),
    transfer: async (payload) => axiosInstance.post('/api/stock/transfer', payload),
    cancelTransfer: async (reference, reason) => axiosInstance.post('/api/stock/transfer/cancel', null, { params: { reference, reason } }),
    startReconciliation: async (entrepotId = null) => {
        const response = await axiosInstance.post('/api/stock/reconciliation/jobs', null, { params: { entrepotId } });
        window.dispatchEvent(new Event('background-job-started'));
        return response;
    },
    getBackgroundJob: async (jobId) => axiosInstance.get(`/api/jobs/${encodeURIComponent(jobId)}`),
    reconciliationResult: async (jobId) => axiosInstance.get(`/api/stock/reconciliation/jobs/${jobId}/result`),
    adjustStock: async (payload) => {
        return axiosInstance.post(`/api/articles/stock-adjustments`, JSON.stringify(payload));
    },
    listStocks: async ({ entrepotId }) => {
        const params = { entrepotId };
        return axiosInstance.get(`/api/entrepots/stocks`, { params });
    },
    upload: async (payload) => {

        const response = await axiosInstance.post(`/api/entrepots/upload`, payload.formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        window.dispatchEvent(new Event('background-job-started'));
        return response;
    },
    getMouvements: async ({ entrepotId = null, dateFrom = null, dateTo = null, query = null }) => {
        const params = {};

        if (entrepotId) params.entrepotId = entrepotId;
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (query) params.query = query;

        return axiosInstance.get(`/api/stock/mouvements`, { params });
    }


};
export default stockService;
